<template>
  <div>
    <MglGeojsonLayer
      :source-id="getBestDtaGeoJson.data.id"
      :source="getBestDtaGeoJson"
      :layer-id="getBestDtaLineLayer.id"
      :layer="getBestDtaLineLayer"
    />
    <MglGeojsonLayer
      :source-id="getBestDtaGeoJson.data.id"
      :source="getBestDtaGeoJson"
      :layer-id="getBestDtaPointsLayer.id"
      :layer="getBestDtaPointsLayer"
    />
  </div>
</template>

<script>
import { MglGeojsonLayer } from "vue-mapbox";
import { mapGetters } from "vuex";

export default {
  name: "BestDtaLayer",
  components: {
    MglGeojsonLayer,
  },
  computed: {
    ...mapGetters("weatherRouting/voyageDetailsModule", ["getBestDtaGeoJson"]),
    ...mapGetters("weatherRouting/weatherRoutingMapModule", [
      "getBestDtaLineLayer",
      "getBestDtaPointsLayer",
    ]),
  },
};
</script>
